<template>
    <div data-app="true" class="component-wrap">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <!-- v-if="access_prizes" заготовка для проверки доступа -->
            <v-layout
                v-if="!user_role"
                column
                :class="{ 'pa-4': $vuetify.breakpoint.mdAndUp }"
            >
                <v-breadcrumbs
                    class=" pl-0"
                    :class="{ 'mx-3': $vuetify.breakpoint.smAndDown }"
                >
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon>
                            {{ $t('Главная') }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="/prize_shop">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-2">keyboard_arrow_left</v-icon>
                            {{ $t('Каталог призов') }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <div
                    style="display: flex; justify-content: space-between; align-items: center"
                >
                    <h1
                        style="cursor: default"
                        class="section-title-main my-3 mr-4 font-weight-regular"
                        :class="{ 'px-3': $vuetify.breakpoint.smAndDown }"
                    >
                        {{ $t('Каталог призов') }}
                    </h1>
                    <div @click="goToOrders">
                        <buttonBdWhite>{{ $t('Мои заказы') }}</buttonBdWhite>
                    </div>
                </div>
                <v-layout>
                    <v-tabs
                        v-model="active"
                        slot="extension"
                        color="white"
                        :slider-color="active_tab === 0 ? '#e2173d' : '#e2173d'"
                        :class="{
                            'flex xs12': $vuetify.breakpoint.xs,
                            'mb-4': $vuetify.breakpoint.smAndDown,
                            'mb-5': $vuetify.breakpoint.mdAndUp,
                        }"
                    >
                        <v-tab
                            v-if="
                                user.role_code === 'ADMINISTRATOR' ||
                                    user.role_code === 'REPLACEMENT_PERSON' ||
                                    user.role_code === 'RESPONSIBLE_PERSON'
                            "
                            class="wrapper-relative--custom"
                            :active-class="'active__user'"
                            @click="sorting_by_type('Призы для организаций')"
                        >
                            {{ $t('Призы для организаций') }}
                        </v-tab>
                        <v-tab
                            class="wrapper-relative--custom"
                            :active-class="'active__user'"
                            @click="sorting_by_type('Призы для пользователей')"
                        >
                            {{ $t('Призы для пользователей') }}
                        </v-tab>
                    </v-tabs>
                </v-layout>
                <v-layout
                    wrap
                    align-center
                    class="pb-4"
                    :class="{
                        'mb-3': $vuetify.breakpoint.xs,
                        'px-3': $vuetify.breakpoint.smAndDown,
                        'border-bottom': $vuetify.breakpoint.mdAndUp,
                    }"
                    style="max-width: 1200px; width: 100%"
                >
                    <template
                        v-if="$vuetify.breakpoint.smAndUp || filters_showed"
                    >
                        <v-flex md2 sm6 xs12
                                mb-4
                        >
                            <v-select
                                :items="[
                                    $t('По возрастанию баллов'),
                                    $t('По убыванию баллов'),
                                ]"
                                solo
                                append-icon=""
                                :label="$t('По возрастанию баллов')"
                                class="custom__input"
                                @change="sorting_by_price($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-flex>
                        <v-flex md4 sm6 xs12
                                mb-4
                        >
                            <div class="switch__container">
                                <label class="switch">
                                    <input
                                        v-model="filtered"
                                        type="checkbox"
                                        :checked="price_filter"
                                    >
                                    <span class="slider round"></span>
                                </label>

                                <div class="switch__container-text">
                                    {{ $t('Только доступные по количеству баллов') }}
                                </div>
                            </div>
                        </v-flex>
                        <div v-show="isInventarisation" class="switch__container-text">
                            <span class="prize-catalog__description">Уважаемые пользователи! <br>
                                На время проведения инвентаризации заказ сувениров временно недоступен. Возможность оформления заказов будет доступна после окончания инвентаризации.
                            <br> Приносим извинения за временные неудобства.</span>
                        </div>
                        <v-flex
                            md4
                            sm6
                            xs12
                            mb-4
                            :class="{
                                'pl-0': $vuetify.breakpoint.smAndDown,
                                'pl-4': $vuetify.breakpoint.mdAndUp,
                            }"
                        />
                    </template>
                </v-layout>
                <v-layout column>
                    <template v-if="paginated.length !== 0">
                        <div class="catalog__custom">
                            <PrizeItem
                                v-for="(prize, i) in paginated"
                                :id="i"
                                :key="i"
                                :content="prize"
                                :prize_access="!!access_my_prizes"
                            />
                        </div>
                    </template>
                    <div v-else class="basket-table-no-item">
                        {{ $t('Нет доступных призов') }}
                    </div>
                </v-layout>
                <v-flex md5 sm12 xs12
                        mb-4
                >
                    <div
                        v-if="
                            filtered_by_theme.length > 10 && pages.length > 10
                        "
                        class="text-xs-center"
                    >
                        <v-pagination
                            v-model="page"
                            :length="
                                Math.ceil(
                                    filtered_by_theme.length / selected_number
                                )
                            "
                            :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                            prev-icon="arrow_back_ios"
                            next-icon="arrow_forward_ios"
                        />
                    </div>
                </v-flex>
            </v-layout>
            <div v-else class="pa-4">{{ $t('Доступ запрещён') }}</div>
        </div>
        <!--        <v-dialog :value="prizes_info_modal" persistent content-class="scrolled-dialog">
            <prizeInfoModal v-if="prizes_info_modal" :prize_access="!!access_my_prizes" />
        </v-dialog>
        <v-dialog :value="get_prize_modal" persistent :width="$vuetify.breakpoint.mdAndUp ? 550 : 'auto'"
                  no-click-animation
        >
            <getPrizeModal />
        </v-dialog>-->
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import UserMenu from '@/components/blocks/common/User_menu.vue';
import FooterBlock from '@/components/blocks/common/Footer.vue';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import checkbox from '@/components/ui/inputs/base/checkbox.vue';
import PrizeItem from '@/components/view_blocks/Prize_shop/Prize_shop_item';
import prizeInfoModal from './Prize_shop_modals/Prize_info_modal';
import getPrizeModal from './Prize_shop_modals/Get_prize_modal';

import {mapGetters, mapMutations, mapActions, mapState} from 'vuex';
import Input from '@inputs/base/input';

export default {
  components: {
    Input,
    HeaderMenu,
    UserMenu,
    FooterBlock,
    buttonBdWhite,
    checkbox,
    PrizeItem,
    prizeInfoModal,
    getPrizeModal,
  },
  data() {
    return {
      isInventarisation: false,
      filters_showed   : false,
      access_prizes    : null,
      access_my_prizes : null,
      pages            : [],
    };
  },
  watch: {
    sorting_type(newValue) {
      if (newValue === 'users') {
        this.pages = this.my_prizes.filter(
            (item) =>
              item.MAIN_PRODUCT.THEME === 'Призы для пользователей'
        );
      } else {
        this.pages = this.my_prizes.filter(
            (item) => item.MAIN_PRODUCT.THEME === 'Призы для организаций'
        );
      }
    },
  },
  computed: {
    user_role() {
      const user = JSON.parse(localStorage.getItem('user'));
      const access = user.access_catalog;
      if (
        (user.achievments.name === 'Эксперт' ||
                    user.achievments.name === 'Знаток') &&
                access
      ) {
        return false;
      } else {
        return true;
      }
    },
    ...mapGetters('profile/user', ['user']),
    ...mapState('prize_shop', ['sorting_type']),
    ...mapGetters('prize_shop/breadcrumbs', ['breadcrumbs']),
    ...mapGetters('prize_shop', [
      'themes',
      'prizes_available',
      'prizes_info_modal',
      'get_prize_modal',
      'prize_recieved_modal',
      'filtered_by_theme',
      'selected_theme',
      'selected_number',
      'selected_page',
      'sorting',
      'paginated',
      'active_tab',
      'price_filter',
      'my_prizes',
    ]),
    theme: {
      get() {
        return this.selected_theme;
      },
      set($event) {
        return this.SET_SELECTED_THEME($event);
      },
    },
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    active: {
      get() {
        return this.active_tab;
      },
      set($event) {
        return this.SET_ACTIVE_TAB($event);
      },
    },
    filtered: {
      get() {
        return this.price_filter;
      },
      set($event) {
        return this.PRICE_FILTER();
      },
    },
  },
  async mounted() {
    await this.get_prizes();
    if (localStorage.user != 'undefined') {
      this.access_prizes = this.user.role.prize_shop.rights.length;
      this.access_my_prizes = this.user.role.my_prizes.rights.length;
      this.pages = this.my_prizes.filter(
          (item) => item.MAIN_PRODUCT.THEME === 'Призы для пользователей'
      );
    }
  },
  methods: {
    ...mapMutations('prize_shop', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_SELECTED_THEME',
      'SET_SELECTED_PAGE',
      'SET_ACTIVE_TAB',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SORT_BY_DATE',
      'PRICE_FILTER',
    ]),
    ...mapActions('prize_shop', [
      'show_number',
      'sorting_by_price',
      'sorting_by_type',
      'get_prizes',
    ]),
    goToOrders() {
      this.$router.push({name: 'prize_order'});
    },
  },
};
</script>

<style lang="sass">

.prize-catalog__description
    font-size: 24px
    color: #4A4A4A
    line-height: 29px
    font-weight: 400
    font-family: 'Futura FuturisC'

.v-list__tile__title
    font-family: 'Futura FuturisC Light'

.switch__container-text
    font-family: 'Futura FuturisC Light'

.custom__input
    border: 1px solid #DEDEDE
    padding: 12px !important
    max-width: 237px
    width: 100%
    font-family: 'Futura FuturisC Light'

label.v-label.theme--light
    font-size: 16px
    color: #4A4A4A

.v-select__selection.v-select__selection--comma
    font-size: 16px
    color: #4A4A4A

.v-tabs__item:not(.v-tabs__item--active)
    opacity: 1

.v-tabs__div.wrapper-relative--custom
    background-color: #DEDEDE
    color: #4A4A4A
    min-width: 183px !important
    width: 100%
    font-size: 14px


.active__user
    background-color: #E4183E
    color: #fff
    width: 100%
    &:hover
        color: #fff
        background-color: #E4183E
        opacity: 0.75

.switch
  position: relative
  display: inline-block
  width: 40px
  height: 20px
  margin: 0 20px 0 40px
  @media screen and (max-width: 599px)
      margin: 0 20px 0 0

  input
      opacity: 0
      width: 0
      height: 0

  &__container
      display: flex
      align-items: center

      &-text
          font-size: 16px
          font-weight: 300
          line-height: 17px


.slider
  position: absolute
  cursor: pointer
  width: 40px
  height: 20px
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #838688
  -webkit-transition: .4s
  transition: .4s


.slider:before
  position: absolute
  content: ""
  height: 16px
  width: 16px
  left: 3px
  bottom: 2px
  background-color: white
  -webkit-transition: .4s
  transition: .4s
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);


input:checked + .slider
  background-color: #E4183E

input:focus + .slider
  box-shadow: 0 0 1px #2196F3


input:checked + .slider:before
  -webkit-transform: translateX(18px)
  -ms-transform: translateX(18px)
  transform: translateX(18px)

/* Rounded sliders */
.slider.round
  border-radius: 34px


.slider.round:before
  border-radius: 50%


.catalog__custom
      display: flex
      flex-wrap: wrap
      flex-direction: row
      margin: 40px 0

      @media screen and (max-width: 768px)
          flex-direction: column
          width: 100%
</style>
